import { Button, Dropdown, DropdownButton, Form, Modal } from 'react-bootstrap'
import { shuffleArray } from '../../Commons/Functions'
import { SECTIONS } from '../PlayerSection/PlayerSection'
import { v4 as uuidv4 } from 'uuid';
import { ACTION_MODES } from '../ActionMode';
import { use, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import CustomDropdownButton from '../GameElements/CustomDropdownButton';

export default function CardQuickActions(props) {
    const [showNotesModal, setShowNotesModal] = useState(false)
    const menuRef = useRef(null);
    const [correctedPos, setCorrectedPos] = useState(props.position);

    useEffect(() => {
        if (props.show && menuRef.current) {
            const menuRect = menuRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - props.position.top;
            const spaceAbove = props.position.top;
            const menuHeight = menuRect.height || 200; // default guess before rendering

            const shouldFlip = menuHeight > spaceBelow && spaceAbove > spaceBelow;
            let top = shouldFlip
                ? Math.max(props.position.top - menuHeight, 10) // flip above
                : props.position.top;

            let left = Math.min(props.position.left, window.innerWidth - menuRect.width - 10);
            top = shouldFlip ? top + 20 : top - 20
            left = left - menuRect.width / 2
            setCorrectedPos({ top, left });
        }
    }, [props.show]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target) && !showNotesModal) {
                close(); // Only close if click is *outside* the menu
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [props.onClose, showNotesModal]);

    function close() {
        setShowNotesModal(false)
        props.setIsTextInputFocused(false)
        props.onClose()
    }

    function ungroupCard(c) {
        if (c.grouppedCards) {
            c.grouppedCards.forEach((child, j) => {
                if (child.position) {
                    delete child.grouppedToId
                    child.position.section = c.position.section
                    child.position.index = 99999
                }
            })
            delete c.grouppedCards
        }

        if (c.grouppedToId !== undefined) {
            // Remove from parent
            let index = props.cards.findIndex((a) => a.id === c.grouppedToId)
            let parent = index >= 0 ? props.cards[index] : false
            if (parent) {
                if (parent.grouppedCards) {
                    let newGrouppedCards = [...parent.grouppedCards]
                    const index = newGrouppedCards.findIndex((a) => a.id === c.id)
                    if (index !== -1) {
                        newGrouppedCards.splice(index, 1)
                    }
                    if (newGrouppedCards.length === 0) {
                        delete parent.grouppedCards
                    } else {
                        parent.grouppedCards = newGrouppedCards
                    }
                }
                //cardSection = parent.position.section // In case of children, use the parent section value
            }
            delete c.grouppedToId
        }
    }

    function sendToDeckTop() {
        if (!props.deck) { return }
        let c = { ...props.cards.splice(props.index, 1)[0] }
        ungroupCard(c)
        c.counters = [{}, {}]
        props.deck.current.push(c)
        props.repositionCards()
        props.sendToHistory("put at the top of their deck", props.card)
        close()
    }

    function sendToDeckBottom() {
        if (!props.deck) { return }
        let c = { ...props.cards.splice(props.index, 1)[0] }
        ungroupCard(c)
        c.counters = [{}, {}]
        props.deck.current.unshift(c)
        props.repositionCards()
        props.sendToHistory("put at the bottom of their deck", props.card)
        close()
    }

    function shuffleIntoDeck() {
        if (!props.deck) { return }
        let c = { ...props.cards.splice(props.index, 1)[0] }
        ungroupCard(c)
        c.counters = [{}, {}]
        props.deck.current.push(c)
        shuffleArray(props.deck.current)
        props.repositionCards()
        props.sendToHistory("deck has been shuffled", props.card)
        close()
    }

    function flip() {
        const c = props.cards[props.index]
        const isFlipped = !c.isFlipped

        c.isFlipped = isFlipped
        props.cards[props.index].isHorizontal = isFlipped ? c.cardData.face.back.isHorizontal : c.cardData.face.front.isHorizontal

        props.moveCard(c, c.position.section)
        props.repositionCards()
    }

    function hide(val) {
        if (val == "yes") {
            [...props.opponentIds, props.playerId].forEach(id => {
                props.card.hiddenTo[id] = true
            })
            props.sendToHistory("hid a card")
        } else if (val == "opponent-only") {
            props.card.hiddenTo = {}
            props.opponentIds.forEach(id => {
                props.card.hiddenTo[id] = true
            })
            props.sendToHistory("hid a card from other players")
        } else if (val == "no") {
            props.card.hiddenTo = {}
            props.sendToHistory("revealed", props.card)
        } else {
            if (props.card.hiddenTo[val]) {
                delete props.card.hiddenTo[val]
                props.sendToHistory("hid a card from one player", props.card)
            } else {
                props.card.hiddenTo[val] = true
                props.sendToHistory("revealed a card to one player", props.card)
            }
        }
        props.moveCard(props.card, props.card.position.section)
        props.repositionCards()
    }

    function group() {
        props.setCurrentActionMode({
            action: ACTION_MODES.GROUP,
            actionData: {
                cardToGroupIndex: props.index,
                cardName: props.cards[props.index].cardData.name
            }
        })
        close()
    }

    function ungroup() {
        let parentSection = SECTIONS.DISCARD
        let index = props.cards.findIndex((a) => a.id === props.card.grouppedToId)
        let parent = index >= 0 ? props.cards[index] : false
        if (parent) {
            parentSection = parent.position.section
        }

        ungroupCard(props.card)
        props.card.position.section = parentSection
        console.log(parentSection)
        props.card.position.index = 9999
        props.repositionCards()
        close()
    }

    function toggleCounter(index) {
        if (props.card.counters[index].value !== undefined) {
            props.card.counters[index] = {}
        } else {
            props.card.counters[index] = {
                value: 0
            }
        }
        props.repositionCards()
    }

    function exile(exileSection) {
        let c = props.cards[props.index]
        props.moveCard(c, exileSection)
        props.repositionCards()
        close()
    }

    function duplicate() {
        let c = JSON.parse(JSON.stringify(props.cards[props.index]))
        c.id = uuidv4()
        c.isToken = true
        c.tokenCount = 1
        if (c.grouppedToId) {
            let index = props.cards.findIndex((a) => a.id === c.grouppedToId)
            if (index >= 0) {
                c.position.section = props.cards[index].position.section
                c.position.index = 9999
            }
        }
        delete c.grouppedToId
        delete c.grouppedCards
        props.cards.push(c)
        props.repositionCards()
        close()
    }

    if (!props.show) return null;

    let leaveTimeout = null;

    return ReactDOM.createPortal(
        <div
            style={{
                position: 'absolute',
                top: correctedPos.top,
                left: correctedPos.left
            }}
            onMouseEnter={() => clearTimeout(leaveTimeout)}
            onMouseLeave={() => {
                leaveTimeout = setTimeout(() => {
                    close();
                }, 400); // Grace period
            }}
        >
            <Dropdown.Menu show className="show" ref={menuRef}>
                {!props.card.isToken && props.card.owner === props.playerId && (
                    <CustomDropdownButton drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title="To deck" className="w-100">
                        <Dropdown.Item href="" onClick={() => sendToDeckTop()}>Top</Dropdown.Item>
                        <Dropdown.Item href="" onClick={() => sendToDeckBottom()}>Bottom</Dropdown.Item>
                        <Dropdown.Item href="" onClick={() => shuffleIntoDeck()}>Shuffle</Dropdown.Item>
                    </CustomDropdownButton>)}
                <Dropdown.Item href="" onClick={() => exile(SECTIONS.EXILE)}>Remove</Dropdown.Item>
                <Dropdown.Item href="" onClick={() => exile(SECTIONS.EXILE_HIDDEN)}>Remove hidden</Dropdown.Item>
                <Dropdown.Divider />
                {props.card.cardData.face.back && (<Dropdown.Item href="" onClick={() => flip()}>Flip</Dropdown.Item>)}
                <CustomDropdownButton drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title="Visible by" className="submenu w-100">
                    <Dropdown.Item href="" onClick={() => hide("no")}>All</Dropdown.Item>
                    <Dropdown.Item href="" onClick={() => hide("yes")}>No one </Dropdown.Item>
                    <Dropdown.Item href="" onClick={() => hide("opponent-only")}>Only you</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item className={!props.card.hiddenTo[props.playerId] ? "selected" : ""} href="" onClick={() => hide(props.playerId)}>You</Dropdown.Item>
                    {props.opponentIds.map((o, i) => {
                        if (props.opponentsData && props.opponentsData[o]) {
                            return (<Dropdown.Item className={!props.card.hiddenTo[o] ? "selected" : ""} key={o} onClick={() => hide(o)}>{props.opponentsData[o].profileData.name}</Dropdown.Item>)
                        }
                    })}
                </CustomDropdownButton>
                {!props.card.grouppedCards && (<Dropdown.Item href="" onClick={() => group()}>Group</Dropdown.Item>)}
                {props.card.grouppedToId && (<Dropdown.Item href="" onClick={() => ungroup()}>Ungroup</Dropdown.Item>)}
                <Dropdown.Item href="" onClick={() => duplicate()}>Duplicate</Dropdown.Item>
                <Dropdown.Divider />
                <CustomDropdownButton drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title="Give to player" className="submenu w-100">
                    {props.opponentIds.map((o, i) => {
                        if (props.opponentsData && props.opponentsData[o]) {
                            return (<Dropdown.Item key={o} onClick={() => {
                                ungroupCard(props.card)
                                props.giveCardAtIndexTo(props.index, o)
                            }}>{props.opponentsData[o].profileData.name}</Dropdown.Item>)
                        }
                    })}
                </CustomDropdownButton>
                <Dropdown.Divider />
                {props.card.counters && (<Dropdown.Item className={props.card.counters[0].value === undefined ? "" : " selected"} onClick={() => toggleCounter(0)}>Toggle counter 1</Dropdown.Item>)}
                {props.card.counters && (<Dropdown.Item className={props.card.counters[1].value === undefined ? "" : " selected"} onClick={() => toggleCounter(1)}>Toggle counter 2</Dropdown.Item>)}
                <Dropdown.Item href="" onClick={() => { setShowNotesModal(true); props.setIsTextInputFocused(true) }}>Edit notes</Dropdown.Item>
            </Dropdown.Menu>
            <EditCardNotesModal
                card={props.card}
                show={showNotesModal}
                handleClose={() => { setShowNotesModal(false); props.setIsTextInputFocused(false) }}
                repositionCards={() => { props.repositionCards(); close(); }}
            />
        </div>,
        document.body
    );
}

function EditCardNotesModal(props) {
    const [notes, setNotes] = useState("")
    return (
        <Modal className="" onEnter={() => setNotes(props.card.notes)} show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit notes</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form.Control
                    className="text-start position-relative"
                    as="textarea"
                    placeholder="Notes..."
                    autoFocus
                    defaultValue={notes}
                    rows={3}
                    onChange={(e) => {
                        setNotes(e.currentTarget.value)
                    }}
                    style={{ resize: "none" }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" className="me-auto" onClick={() => {
                    setNotes("")
                    props.card.notes = ""
                    props.handleClose()
                    props.repositionCards()
                }}>
                    Delete
                </Button>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {
                    props.card.notes = notes
                    props.repositionCards()
                    props.handleClose()
                }}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    )
}